import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API } from '../../ApiNames';


export const fetchApproveSuccess = (dataapprove: any) => ({
    type: 'FETCH_Approve_SUCCESS',
    payload: dataapprove,
});
export const fetchRejectSuccess = (datareject: any) => ({
    type: 'FETCH_Reject_SUCCESS',
    payload: datareject,
});export const fetchHoldSuccess = (datahold: any) => ({
    type: 'FETCH_Hold_SUCCESS',
    payload: datahold,
});


export const ApproveData = (SupervisorID:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:7,asid: SupervisorID};
            const apiname = Admin_API.Hospital_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchApproveSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const RejectData = (SupervisorID:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:5,asid: SupervisorID};
            const apiname = Admin_API.Hospital_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchRejectSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const HoldData = (SupervisorID:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:6,asid: SupervisorID};
            const apiname = Admin_API.Hospital_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchHoldSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

